import axiosAuth from '../../axiosMain';

async function update(id) {
  let response = await axiosAuth.post('/approve_question/' + id);
  return response.data;
}

// async function destroy(id) {
//   let response = await axiosAuth.delete('/questions/' + id);
//   return response.data.data
// }

export default {
  update,
};
